import { apiErrorText, apiErrorTitle } from 'shared/api/error-message';
import { i18n } from 'shared/i18n';
import { dispatchMessage, EventType } from 'shared/feedback/toasts';

const ServerErrorHandler = (e: unknown) => {
  console.error(e);

  dispatchMessage(EventType.ADD_MESSAGE, {
    type: 'error',
    title: apiErrorTitle(e, i18n('server:error.undefined.title')),
    text: apiErrorText(e, i18n('server:error.undefined.message')),
  });
};

export default ServerErrorHandler;
